<template>
  <v-container>
    <div class="contain">
      <p v-if="buildCard">
        <v-card flat class="outCard">
          <v-row>
            <v-col cols="2" style="margin-left: 12px">
              <ryou-select
                v-model="selectBuildName"
                :value="selectBuildName"
                :items="buildItems"
                :itemText="'code_text'"
                :itemValue="'code_value'"
              >
              </ryou-select>
            </v-col>
            <v-col
              cols="1.5"
              v-for="(codeItem, cindex) in codeList"
              :key="cindex"
            >
              <v-card :color="colors[cindex].stColor">
                <b>{{ codeItem.code_text }}:</b>
                {{ absenceCnt[cindex] }}
              </v-card>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-label>{{ nowTime }}</v-label>
            </v-col>
          </v-row>
        </v-card>
      </p>
      <v-container>
        <BuildingBeingStatusDialog ref="buildingBeingForm" @ok="statusFormOk">
        </BuildingBeingStatusDialog>
      </v-container>
      <v-card flat class="outCard">
        <v-row
          v-for="(florItems, fIndex) in florList"
          :key="fIndex"
          class="florRow"
        >
          <v-col cols="1" style="max-width: 5%"
            >{{ floorValue[fIndex] }}階{{ florItems.length }}室</v-col
          >
          <v-col cols="11">
            <v-row>
              <v-col
                v-for="(florVal, index) in florItems"
                :key="index"
                class="flex-grow-0 pl-1 pr-1 pb-0"
              >
                <v-card
                  :color="colors[florVal.abs_info].stColor"
                  style="min-width: 200px; min-height: 60px"
                >
                  <v-card-text class="text-center pl-0 pr-0 pb-0 pt-2">
                    {{ florVal.room_id }}：{{ florVal.user_name }}
                    <br />
                    {{ florVal.final_date }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <p v-if="hanCal">
            <v-card
              v-if="floorValue[fIndex] == '1'"
              width="200px"
              flat
              class="flex-grow-1"
            >
              <v-row class="text-center">
                <v-col
                  cols="1.5"
                  v-for="(codeItem, cindex) in codeList"
                  :key="cindex"
                >
                  <v-card
                    :color="colors[cindex].stColor"
                    style="min-height: 100px"
                  >
                    <b>{{ colors[cindex].stUsageMsg }}</b>
                    <v-card-subtitle style="white-space: pre" class="mb-n2">{{
                      colors[cindex].stMsg
                    }}</v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </p>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import BuildingBeingStatusDialog from "./modules/BuildingBeingStatusDialog.vue";

export default {
  name: "BuildingBeingStatusList",
  components: {
    RyouSelect,
    BuildingBeingStatusDialog,
  },
  data: () => ({
    buildCard: true,
    hanCal: false,
    valid: true,
    selectBuildName: "",
    nowTime: "",
    buildItems: [],
    floorValue: [],
    contentHasValue: [],
    codeList: [],
    florList: [],
    absenceCnt: [],
    intervalId: null,
    colCnt: 12,
    //allFloorValue: [],
    //roomsValue: [],
    colors: [
      {
        beingStatus: "0",
        stColor: "#EE82EE",
        stUsageMsg: "在館",
        stMsg: "館内にいます。",
      },
      {
        beingStatus: "1",
        stColor: "#ED5A5A",
        stUsageMsg: "長期在館\n(３日以上)",
        stMsg: "長時間館内にいます。\n確認してください。",
      },
      {
        beingStatus: "2",
        stColor: "#ffffff",
        stUsageMsg: "不在",
        stMsg: "不在中です。\n館内にいません。",
      },
      {
        beingStatus: "3",
        stColor: "#FFFF00",
        stUsageMsg: "長期不在\n(３日以上、連絡無)",
        stMsg: "長期不在中です。\n連絡がありません。",
      },
      {
        beingStatus: "4",
        stColor: "#90CAF9",
        stUsageMsg: "長期不在\n(３日以上、連絡有)",
        stMsg: "長期不在中です。\n連絡済みです。",
      },
      {
        beingStatus: "5",
        stColor: "#808080",
        stUsageMsg: "未使用",
        stMsg: "入寮していません。",
      },
    ],
  }),
  watch: {
    // 物件グループ選択
    selectBuildName(value) {
      if (value != null && value != "") {
        this.clear();
        this.selectUserClassJudge();
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    //在館状況更新画面を表示する。
    handlerClick(item) {
      this.$refs.buildingBeingForm.edit(item[0]);
    },
    //在館状況表示更新
    statusFormOk() {
      this.clear();
      this.selectUserClassJudge();
    },
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/buildingBeingStatusList/buildNameListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.buildItems = data.result; //物件名
          this.selectBuildName = this.buildItems[0].code_value;
        }
      });
      setTimeout(() => {}, 100);
    },
    selectUserClassJudge() {
      this.setTime();
      var that = this;
      let params = {
        building_id: this.selectBuildName,
      };
      this.getRequest(
        "/buildingBeingStatusList/buildingBeingStatusListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          that.contentHasValue = data.result;
          // 各部屋の状況
          that.codeList = that.contentHasValue.codeList;
          that.absenceCnt = that.contentHasValue.absenceCnt;
          that.florList = that.contentHasValue.tEntryInfoList;
          that.floorValue = that.contentHasValue.florList;
        }
      });
    },
    clear() {
      this.floorValue = [];
      this.contentHasValue = [];
      this.roomsValue = [];
    },
    setTime() {
      var dt = new Date();
      var year_str = dt.getFullYear();
      //月だけ+1すること
      var month_str = 1 + dt.getMonth();
      var day_str = dt.getDate();
      var hour_str = dt.getHours();
      var minute_str = dt.getMinutes();
      var second_str = dt.getSeconds();
      var format_str = "YYYY/MM/DD hh:mm:ss";
      format_str = format_str.replace(/YYYY/g, year_str);
      format_str = format_str.replace(/MM/g, month_str);
      format_str = format_str.replace(/DD/g, day_str);
      format_str = format_str.replace(/hh/g, hour_str);
      format_str = format_str.replace(/mm/g, minute_str);
      format_str = format_str.replace(/ss/g, second_str);
      this.nowTime = format_str;
    },
    reShow() {
      this.selectUserClassJudge();
    },
  },
  mounted: function () {
    this.intervalId = setInterval(this.reShow, 10000);
  },
  beforeDestroy: function () {
    clearInterval(this.intervalId);
  },
};
</script>

<style scoped>
.outCard {
  padding-top: 10px;
  height: 30px;
}

.contain {
  padding-left: 2%;
  width: 1900px;
}

.selfCard {
  padding-top: 1%;
  overflow-x: scroll !important;
  overflow-y: scroll !important;
}
.florRow {
  white-space: nowrap;
  justify-content: left;
}
.ryoRooms {
  width: 258px;
  height: 230px;
  padding-left: 10px;
  margin: 10px 0px;
  display: inline-block;
  vertical-align: middle;
}

.ryoDivtitle {
  width: 230px;
  outline: 1px solid black;
  padding: 0px 0px;
  text-align: center;
  height: 25px;
  font-size: 15px;
}

.roww {
  height: 26px;
}

.showUserInfo {
  height: 200px;
  padding: 0px 0px;
}

.ryokinDiv {
  text-align: center;
  padding-top: 3%;
  height: 60px;
  font-size: 12px;
}

.ryokinAff {
  text-align: center;
  padding-top: 3%;
  height: 60px;
  font-size: 12px;
}

.ryokinDate {
  text-align: center;
  padding-top: 3%;
  height: 35px;
  font-size: 12px;
}

.ryokinDor {
  text-align: center;
  padding-top: 3%;
  height: 45px;
  font-size: 12px;
  color: red;
}

.ryoCol {
  padding: 0px 10px;
}

.ryoCols {
  border-right: solid 1px black;
  width: 30%;
  padding: 0px 0px;
}

.ryoCard {
  outline: 1px solid black;
  width: 230px;
  margin-top: 12px;
}

.v-card__text {
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}
</style>
